import { AxiosPromise, CancelToken } from 'axios';
import { InboxItemsResponse } from '../sic-lib/api/newRecent/types/InboxItemsResponse';
import { apiInstance as instance } from './';

/**
 * requestNewMessages
 *
 * @description
 * Makes a HTTP request to retrieve a client new messages
 */
export function requestNewMessages(
    data: {},
    cancelToken: CancelToken,
): AxiosPromise<InboxItemsResponse> {
    return instance.post(`/contacts/inbox`, data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

/**
 * requestNewMessages
 *
 * @description
 * Makes a HTTP request to retrieve a client Unresponded messages
 */
export function requestUnrespondedMessages(
    data: {},
    cancelToken: CancelToken,
): AxiosPromise<InboxItemsResponse> {
    return instance.post(`dashboard/unread`, data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
